import React from "react";
import Particle from "../Particle/Particle";
import SkillBar from "../SkillBar/SkillBar";

const Skills = () => {
  const skillItems = [
    {
      id: 1,
      name: "HTML",
      value: 90,
    },
    {
      id: 2,
      name: "CSS",
      value: 85,
    },
    {
      id: 3,
      name: "Javascript",
      value: 95,
    },
    {
      id: 8,
      name: "Typescript",
      value: 92,
    },
    {
      id: 4,
      name: "React",
      value: 90,
    },
    {
      id: 5,
      name: "Next JS",
      value: 85,
    },
    {
      id: 6,
      name: "MongoDB",
      value: 83,
    },
    {
      id: 7,
      name: "PostgreSQL",
      value: 80,
    },
  ];

  return (
    <section className="md:h-[100vh] grid lg:grid-cols-2 md:grid-cols-1 mt-12 lg:mt-0">
      <Particle></Particle>
      <div className="bg-secondary w-full lg:h-[100vh] md:pt-20 md:pb-28 pb-6 flex items-center justify-center">
        <div className="w-1/2">
          <div className="flex items-center justify-center xl:justify-start mt-8 xl:mt-0">
            <div className="border-t-2 w-1/5 mr-4 border-primary"></div>
            <div>
              <p className="text-xl font-medium text-white">My Skills</p>
            </div>
          </div>
          <div className="py-20 md:py-0">
            {skillItems.map((skill) => (
              <SkillBar key={skill.id} skill={skill}></SkillBar>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
